import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-delete-bulk-registration',
  imports: [SharedModule],
  templateUrl: './delete-bulk-registration.component.html',
  styleUrl: './delete-bulk-registration.component.scss'
})
export class DeleteBulkRegistrationComponent {

  @Output() closeDialog = new EventEmitter();
  @Input() selectedProducts: any[] = [];
  @Output() reload = new EventEmitter<any>();
  isLoading = false;

  constructor(
    private localStorage: LocalStorageService,
    private api: RegistrationService,
    private messageService : MessageService

  ) { }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  handleDelete() {

    const payload = {
      organization_id:this.localStorage.getOrganizationId(),
      reg_id: this.selectedProducts.map((item) => item.registration.reg_id),
      lead_id: this.selectedProducts.map((item) => item.lead_id)
    };
    this.isLoading = true;
    this.api.deleteBulkRegistration(payload).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.reload.emit();
        this.closeDialog.emit();
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message
        });
      },
      error: (error) => {
        this.isLoading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error.error.message
        });
      }

    }
    );
  }
}
